import React, { useState } from "react";

const AddDepartmentForm = ({ onClose, onDepartmentAdded }) => {
  const [formData, setFormData] = useState({
    department_code: "",
    department_name: "",
    description: ""
  });

  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.department_name) {
      setError("Department name are required.");
      return;
    }

    try {
      const response = await fetch("/api/departments/add-Department", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to add department.");
      }

      alert("✅ Department added successfully!");
      setTimeout(() => {
        onDepartmentAdded(); // Refresh user list
        onClose(); // Close modal
      }, 300);
    } catch (error) {
      console.error("❌ Error adding Department:", error.message);
      setError(error.message || "An error occurred.");
    }
  };

  return (
    /** ✅ Wrap everything in a <div> to avoid ESLint error */
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add Department</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label id="add-user-label">Department Code:</label>
            <input id="add-user-input" type="text" name="department_code" value={formData.department_code} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label id="add-user-label">Department Name:</label>
            <input id="add-user-input" type="text" name="department_name" value={formData.department_name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Description:</label>
            <input id="add-user-input" type="text" name="description" value={formData.description} onChange={handleChange} />
          </div>         
            {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn">Add Department</button>
        </form>
      </div>
    </div>
  );
};

export default AddDepartmentForm;
